import 'styles/index.css';

import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { ThemeProvider } from 'theme-ui';

import App from 'components/App';
import store from 'store';
import { theme } from 'ui';

const router = createBrowserRouter([
  {
    path: '*',
    element: (
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <App />
        </ThemeProvider>
      </Provider>
    ),
  },
]);

createRoot(document.getElementById('root')!).render(<RouterProvider router={router} />);
